import { GetApp } from "../../App"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IShipVesselType } from "../../Types"
import { PrintShipViewData } from "./Context"
import { PrintShipGeneralViewProps } from "./Params"

// General information and owner details.
export function PrintShipGeneralView({ data }: PrintShipGeneralViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  return (
    <PrintListBlock title={t("general")} blockClassName="PrintShipView-block-left">
      <BlockRow>
        <BlockField label={t("mmsi")} className="block-field-120">{shipData?.mmsi}</BlockField>
        <BlockField label={t("callsign")} className="block-field-120">{shipData?.callsign}</BlockField>
        <BlockField label={t("home_port")} className="block-field-120">{shipData?.homePort}</BlockField>
        <BlockField label={t("flag")} className="block-field-120">{shipData?.flag}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("reg_number")} className="block-field-120">{shipData?.regNumber}</BlockField>
        <BlockField label={t("hin")} className="block-field-120">{shipData?.hin}</BlockField>
        <BlockField label={t("imo")} className="block-field-120">{shipData?.imo}</BlockField>
        <BlockField label={t("build_number")} className="block-field-120">{shipData?.yachtBuildNumber}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("vessel_type")} className="block-field-120">{shipData?.vesselType === IShipVesselType.motor ? app.getT("ShipEditView")("type_motor") : shipData?.vesselType === IShipVesselType.sailing ? app.getT("ShipEditView")("type_sailing") : shipData?.vesselType}</BlockField>
        <BlockField label={t("yachtbuilder")} className="block-field-120">{shipData?.yachtYachtBuilder}</BlockField>
        <BlockField label={t("model_name")} className="block-field-120">{shipData?.yachtModelName}</BlockField>
        <BlockField label={t("year")} className="block-field-120">{shipData?.yachtYearBuild}</BlockField>
      </BlockRow>
      <BlockRow>
        <BlockField label={t("construction")} className="block-field-120">{shipData?.yachtConstruction}</BlockField>
        <BlockField label={t("designer")} className="block-field-120">{shipData?.yachtDesigner}</BlockField>
        <BlockField label={t("cel")} className="block-field-120">{shipData?.cel}</BlockField>
        <BlockField label={t("cel_persons")} className="block-field-120">{shipData?.celPersons}</BlockField>
      </BlockRow>

      <BlockRow>
        <h3>{t("owner")}</h3>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("owner_name")} className="block-field-270">{shipData?.ownerName}</BlockField>
        <BlockField label={t("owner_phone")}>{shipData?.ownerPhone}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("owner_email")} className="block-field-270">{shipData?.ownerEmail}</BlockField>
        <BlockField label={t("owner_address")}>{shipData?.ownerAddress}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("yacht_club")} className="block-field-270">{shipData?.yachtClubName}</BlockField>
        <BlockField label={t("yacht_club_address")}>{shipData?.yachtClubAddress}</BlockField>
      </BlockRow>
    </PrintListBlock>
  );
}
